<template lang="pug">
include /mixins.pug
+b.ds-panel.--space_xs
  +b.P.ds-caption.--size_xs.--color_black.--regular(
    ref="textRef"
    :class="{ 'comment-clamped': !expanded }"
  ) {{ text }}
  +b.ds-panel.--space_xs(v-if="isClamped")
    +e.element.--offset_top
      +b.SPAN.ds-link.--color_main.--size_xs(
        @click="toggleExpanded"
      ) {{ expanded ? _("Згорнути") : _("Розгорнути") }}
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    expandedGlobal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isClamped: false,
      expanded: false,
    }
  },

  watch: {
    text: {
      immediate: true,
      handler() {
        this.checkClamped()
      },
    },
    expandedGlobal: {
      immediate: true,
      handler(nval) {
        this.expanded = nval
      },
    },
  },

  mounted() {
    this.checkClamped()
  },

  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
    },

    async checkClamped() {
      await this.$nextTick()

      const el = this.$refs.textRef

      if (el) {
        this.isClamped = el.scrollHeight > el.clientHeight
      } else {
        this.isClamped = false
      }
    },
  },
}
</script>
